export interface ActionsDesktopProps {
	requestSearch: () => void;
}

export const ActionsDesktopComponent = (props: ActionsDesktopProps) => {
	return (
		<div className="actions">
			<ActionComponent faIcon="search" onClick={props.requestSearch} />
		</div>
	);
}

export interface ActionsCompactProps {
	toggleIsMenuExpanded: () => void;
	requestSearch: () => void;
}

export const ActionsCompactComponent = (props: ActionsCompactProps) => {
	return (
		<div className="actions">
			<ActionComponent faIcon="bars" onClick={props.toggleIsMenuExpanded} />
			<ActionComponent faIcon="search" onClick={props.requestSearch} />
		</div>
	);
}

interface ActionProps {
	onClick: () => void;
	faIcon: string;
}

const ActionComponent = (props: ActionProps) => {
	return (
		<a className="action" onClick={props.onClick}>
			<i className={`fa fa-${props.faIcon}`}></i>
		</a>
	);
}